<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="700XAuto"
      no-padding
      center
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>导航布局设置</span>
    </template>
    <template #content>
      <div class="cut-nav-modal">
          <div class="cut-nav-modal-tips">注意：切换导航栏布局方式会关闭所有标签，请注意资料的保存！</div>
          <div class="cut-nav-modal-card">
            <div class="card__left" @click="navState = 'horizontal'" :class="{activate_card: navState === 'horizontal'}">
                <div class="card_text" :class="{activate_text: navState === 'horizontal'}">顶部导航</div>
                <div class="card_content">
                    <div class="card-solid"></div>
                    <div class="card-chunk" :class="{activate_chunk: navState === 'horizontal'}"></div>
                </div>
                <div class="card-shade" v-show="navState === 'horizontal'"></div>
            </div>
              <div class="card__right" @click="navState = 'vertical'" :class="{activate_card: navState === 'vertical'}">
                  <div class="card_text" :class="{activate_text: navState === 'vertical'}">侧边导航</div>
                  <div class="card_content">
                    <div class="card-solid"></div>
                    <div class="card-chunk" :class="{activate_chunk: navState === 'vertical'}"></div>
                  </div>
                  <div class="card-shade" v-show="navState === 'vertical'"></div>
              </div>
          </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import { modalMixIn } from "../../../../minxins";
  import { editUserConfig, queryUserConfig } from '@/api/user';

  export default {
    name: "app-cut-nav-modal",
    mixins: [modalMixIn],
    data() {
        return {
            navState: '',
        }
    },
    created() {
      this.navState = localStorage.getItem('NAV_STATE') || 'horizontal'
    },
    methods: {
        async confirm() {
            if (this.navState === localStorage.getItem('NAV_STATE')) {
                this.modalVisible = false
                return
            }
            const config = {
                name: 'navConfig',
                value: this.navState,
            }
            // await queryUserConfig('navConfig').then(data => {
            //     config.id = data?.id
            // })
            await editUserConfig(config).then(res => {
                if (res.code === 0) {
                    localStorage.setItem('NAV_STATE', this.navState)
                    this.$emit('cutNavConfirm', this.navState)
                    this.modalVisible = false
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
  }
</script>


<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
    .cut-nav-modal-tips{
        font-size: 13px;
        color: #f5222d;
        margin-bottom: 20px;
    }
    .cut-nav-modal{
        padding: 20px;
        .cut-nav-modal-card{
            width: 100%;
            display: flex;
            justify-content: space-between;
            .card__{
                height: 180px;
                border: 1px solid #d8dadd;
                border-radius: 2px;
                width: 48%;
                display: flex;
                flex-direction: column;
                align-items: center;
                display: flex;
                position: relative;
                overflow: hidden;
                cursor: pointer;
            }
            .card-solid__{
                background: $gj-background-color-bg11;
                border-radius: 10px;
            }
            .card-chunk__{
                width: 100%;
                height: 100%;
                background: #e4e5e6;
                border-radius: 4px;
            }
            .card__left{
                @extend .card__;
                .card-solid{
                    width: 100%;
                    height: 12px;
                    margin-bottom: 3px;
                    @extend .card-solid__;
                }
                .card-chunk{
                    @extend .card-chunk__;
                }
                .card_content{
                    flex-direction: column;
                }
            }
            .card__right{
                @extend .card__;
                .card-solid{
                    width: 12px;
                    height: 100%;
                    margin-right: 3px;
                    @extend .card-solid__;
                }
                .card-chunk{
                    @extend .card-chunk__;
                }
                
            }
            .card_text{
                padding: 12px 0;
                font-weight: bold;
            }
            .card_content{
                display: flex;
                flex-grow: 1;
                width: 80%;
                margin-bottom: 20px;
            }
        }
    }
    .activate_text{
        color: #4994fc !important;
    }
    .activate_card{
        border: 1px solid #4994fc !important;
    }
    .activate_chunk{
        background: #c4e3ff !important;
    }
    .card-shade{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #c4e3ff;
        opacity: .2;
    }
</style>